import axios from "axios";

export const uploadFileToS3Promise = (file, uploadURL, headers) => {
  return axios.put(uploadURL, file, {
    headers: headers,
  });
};
